import { jsxs, jsx } from "react/jsx-runtime";
const IconDragDotsSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M10.667 4.667a1.334 1.334 0 1 0 0-2.667 1.334 1.334 0 0 0 0 2.667Zm0 6.666a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667Zm0-4.666a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666Zm-5.334-2a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Zm0 6.666a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667Zm0-4.666a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667Z" })
    ]
  }
);
export {
  IconDragDotsSvg
};
